import React, { Fragment, memo } from 'react';
import style from './NevisPassKeysDialogSection.scss';
import { Icon } from '@core/js/components/common/Icon';
import { useManageDialogSection } from '../../hooks/useManageDialogSection';
import { useRenamePasskey } from '../../hooks/useRenamePasskey';
import { useRevokePasskey } from '../../hooks/useRevokePasskey';
import { INevisDialogSection } from '../../types';
import { PASSKEYS_ACTIONS } from '@theme/js/components/main/NevisPasskeysSwiss/constants';

export const NevisPassKeysDialogSection = memo(({
    data,
    fetchPortlet,
    portletType,
    tkPrefix,
    index,
    t
} : INevisDialogSection) => {
    const { showDialogWindow, onDialogClick } = useManageDialogSection();
    const renamePassKey = useRenamePasskey({
        data,
        fetchPortlet,
        portletType,
        index,
        tkPrefix
    });
    const revokePassKey = useRevokePasskey({
        data,
        fetchPortlet,
        portletType,
        index,
        tkPrefix
    });

    const actionsHandler:Record<string, () => void> = {
        rename: () => renamePassKey(),
        revoke: async () => (await revokePassKey)()
    };

    return (
        <Fragment>
            <Icon className={style.menuIcon} onClick={onDialogClick}/>
            {showDialogWindow && <section className={style.dialogWindow}>
                {PASSKEYS_ACTIONS.map((item, ind) => (
                    <div key={ind} className={style.dialogItem} onClick={actionsHandler[item]}>
                        <Icon className={`${style[item]} ${style.handleIcon}`}/>
                        <div className={style.dialogItemText}>
                            {t(`${tkPrefix}passkeys.${item}`)}
                        </div>
                    </div>
                ))}
            </section>}
        </Fragment>
    );
});
